"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startsWith = void 0;

var _startsWith = function _startsWith(search, source) {
  if (search.length > source.length) {
    return false;
  }

  var searchPosition = source.indexOf(search);

  if (searchPosition === -1) {
    return false;
  }

  return searchPosition === 0;
};
/**
 * Test if string starts with substring
 *
 * @param {String} search Search string
 * @param {String} source Source string
 *
 * @return {Boolean}
 *
 * @name startsWith
 * @tag String
 * @signature (search: String) => (source: String): Boolean
 *
 * @example
 * startsWith("lorem", "lorem ipsum")
 * // => true
 *
 * startsWith("dolor")("lorem ipsum")
 * // false
 */


var startsWith = function startsWith() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  // @signature (search) => (source)
  if (params.length <= 1) {
    return function (source) {
      return _startsWith(params[0], source);
    };
  } // @signature (search, source)


  return _startsWith.apply(void 0, params);
};

exports.startsWith = startsWith;